<template>
  <ui-select
    v-model="(model as any)"
    v-model:show="modelShow"
    label="Editing language"
    >
    <ui-select-option
      v-for="(language,ll) in availableLocales"
      :key="ll"
      :value="language.code"
      :text="language.code"
      :default="language.code == locale"
      >
      <i v-if="(modelLanguagesChecked ?? [])?.includes(language.code)" class="fa fa-check mx-2" />
      <ui-flag :iso="language.code" class="max-w-5 inline-block mx-2"/>
    </ui-select-option>
  </ui-select>
</template>

<script setup lang="ts">
const { locale, locales } = useI18n()

const model = defineModel()
const modelShow = defineModel<boolean>('show')
const modelLanguagesChecked = defineModel<string[]>('languagesChecked')

const availableLocales = computed(() => {
  return locales.value.filter(i => i.code !== 'ru')
})
</script>
